// import CANNON from 'cannon';
import * as CANNON from 'cannon-es';
class Material {
    constructor() {
        this.getIceRockContactMaterial = () => {
            if (!this.iceRockContactMaterial) {
                this.iceRockContactMaterial = new CANNON.ContactMaterial(this.getRockMaterial(), this.getIceMaterial(), {
                    friction: 1,
                    restitution: 0.1,
                    contactEquationRelaxation: 4,
                    frictionEquationRelaxation: 10,
                });
            }
            return this.iceRockContactMaterial;
        };
        this.getIceGlassContactMaterial = () => {
            if (!this.iceGlassContactMaterial) {
                this.iceGlassContactMaterial = new CANNON.ContactMaterial(this.getGlassMaterial(), this.getIceMaterial(), {
                    friction: 0,
                    restitution: 0.1,
                    contactEquationRelaxation: 10,
                    frictionEquationRelaxation: 10,
                });
            }
            return this.iceGlassContactMaterial;
        };
        this.getIceIceContactMaterial = () => {
            if (!this.iceIceContactMaterial) {
                this.iceIceContactMaterial = new CANNON.ContactMaterial(this.getIceMaterial(), this.getIceMaterial(), {
                    friction: 1,
                    restitution: 1,
                    contactEquationRelaxation: 4,
                    frictionEquationRelaxation: 10,
                });
            }
            return this.iceIceContactMaterial;
        };
        this.getIceSpungeContactMaterial = () => {
            if (!this.iceSpungeContactMaterial) {
                this.iceSpungeContactMaterial = new CANNON.ContactMaterial(this.getIceMaterial(), this.getSpungeMaterial(), {
                    friction: 2,
                    restitution: 2.4,
                });
            }
            return this.iceSpungeContactMaterial;
        };
        this.getIceAdamantineContactMaterial = () => {
            if (!this.iceAdamantineContactMaterial) {
                this.iceAdamantineContactMaterial = new CANNON.ContactMaterial(this.getIceMaterial(), this.getAdamantineMaterial(), {
                    friction: 0,
                    restitution: 1.6,
                    contactEquationRelaxation: 4,
                    frictionEquationRelaxation: 10,
                });
            }
            return this.iceAdamantineContactMaterial;
        };
        this.getIceMithrilContactMaterial = () => {
            if (!this.iceMithrilContactMaterial) {
                this.iceMithrilContactMaterial = new CANNON.ContactMaterial(this.getIceMaterial(), this.getMithrilMaterial(), {
                    friction: 0,
                    restitution: 4.2,
                    contactEquationRelaxation: 4,
                    frictionEquationRelaxation: 10,
                });
            }
            return this.iceMithrilContactMaterial;
        };
    }
    getIceMaterial() {
        if (!this.iceMaterial)
            this.iceMaterial = new CANNON.Material('ice');
        return this.iceMaterial;
    }
    getRockMaterial() {
        if (!this.rockMaterial)
            this.rockMaterial = new CANNON.Material('rock');
        return this.rockMaterial;
    }
    getGlassMaterial() {
        if (!this.glassMaterial)
            this.glassMaterial = new CANNON.Material('glass');
        return this.glassMaterial;
    }
    getSpungeMaterial() {
        if (!this.spungeMaterial)
            this.spungeMaterial = new CANNON.Material('spunge');
        return this.spungeMaterial;
    }
    getAdamantineMaterial() {
        if (!this.adamantineMaterial)
            this.adamantineMaterial = new CANNON.Material('adamantine');
        return this.adamantineMaterial;
    }
    getMithrilMaterial() {
        if (!this.mithrilMaterial)
            this.mithrilMaterial = new CANNON.Material('mithril');
        return this.mithrilMaterial;
    }
}
export default Material;
